import styled from 'styled-components';
import { TabList, Tab } from 'react-tabs';
import Modal from 'react-modal';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 0 40px;
  padding-top: 40px;
  box-sizing: border-box;
`;

export const Title = styled.h1`
  color: #cf0505;
  margin: 40px 0 12px;
  text-align: center;
  font-size: 24px;
`;




export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  border-radius: 8px;
  background: white;

  th, td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    font-size: 14px;
  }

  th {
    background-color: #f0f0f0;
    color: #333;
  }

  tr:nth-child(even) {
    background-color: #f9f9f9;
  }

  tr:hover {
    background-color: #f1f1f1;
  }
`;


export const Form = styled.form`
  width: 100%;
  max-width: 600px;
  background: #f0f0f0;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #cf0505; // Adiciona a borda vermelha
  margin: 0 auto; // Centraliza o formulário na tela

  @media (max-width: 768px) {
    max-width: 90%; // Aumenta a largura para 90% da tela em dispositivos menores
    padding: 15px; // Reduz o padding para criar mais espaço
  }

  @media (max-width: 480px) {
    max-width: 100%; // Ocupa 100% da largura da tela em dispositivos muito pequenos
    padding: 10px; // Reduz ainda mais o padding
  }
`;

export const InputGroup = styled.div`
  margin-bottom: 18px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  color: #cf0505;
  font-weight: 500;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1.5px solid #ccc;
  background: #f5f6fa;
  font-size: 15px;
  transition: border 0.2s, background 0.2s;
  margin-bottom: 4px;
  &:focus {
    border: 1.5px solid #2563eb;
    background: #fff;
    outline: none;
  }
`;

export const Button = styled.button`
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 28px;
  font-size: 16px;
  font-weight: bold;
  margin: 8px 0;
  cursor: pointer;
  transition: background 0.2s;
  min-width: 120px;
  &:hover {
    background: #1741a6;
  }
  &:disabled {
    background: #ccc;
    color: #888;
    cursor: not-allowed;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
`;

export const Fieldset = styled.fieldset`
  border: 1px solid #ddd;
  padding: 10px;
  margin-bottom: 20px;
`;

export const Legend = styled.legend`
  padding: 0 5px;
  color: #333;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

export const Checkbox = styled.input`
  margin-left: 10px;
`;

export const StyledTabList = styled(TabList)`
  list-style-type: none;
  padding: 0;
  margin: 0 0 24px 0;
  display: flex;
  border-bottom: 2px solid #eee;
  background: #fff;
`;

StyledTabList.tabsRole = 'TabList';

export const StyledTab = styled(Tab)`
  padding: 12px 32px;
  cursor: pointer;
  user-select: none;
  text-align: center;
  background: #fff;
  border: none;
  border-bottom: 3px solid transparent;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  transition: border-bottom 0.2s, color 0.2s;
  &:hover {
    color: #2563eb;
    background: #f5f6fa;
  }
  &.react-tabs__tab--selected {
    color: #cf0505;
    border-bottom: 3px solid #cf0505;
    background: #fff;
    font-weight: bold;
  }
`;

StyledTab.tabsRole = 'Tab';

export const TextArea = styled.textarea`
  width: 100%;
  height: 120px;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1.5px solid #ccc;
  background: #f5f6fa;
  font-size: 15px;
  transition: border 0.2s, background 0.2s;
  margin-bottom: 4px;
  resize: vertical;
  &:focus {
    border: 1.5px solid #2563eb;
    background: #fff;
    outline: none;
  }
`;

export const Erro = styled.p`
  color: red;
`;

export const StyledModal = styled(Modal)`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  max-width: 800px;
  width: 90%;
  background: #FFF;
  border-radius: 10px;
  border: none;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

  // Personalize o overlay (fundo) aqui, se necessário
  &:focus {
    outline: none;
  }

  // Para telas pequenas, você pode querer ajustar a largura ou padding
  @media (max-width: 768px) {
    width: 95%;
    padding: 10px;
  }
`;



export const ModalContent = styled.div`
  max-height: 400px; // Ajuste para o valor que você deseja
  overflow-y: auto;
`;

export const StyledAddressModal = styled(Modal)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5); // Fundo escuro semi-transparente
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    width: 80%;
    height: 80%;
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    position: relative; // Para posicionar o botão "Fechar"
    overflow: hidden; // Evita rolagem externa
  }

  @media (max-width: 768px) {
    .content {
      width: 95%;
      padding: 15px;
    }
  }
`;

export const ModalWrapper = styled.div`
  width: 80%;
  height: 80%;
  margin: auto;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  background: #fff;
  position: absolute;
  top: 50%; /* Centraliza verticalmente */
  left: 50%;
  transform: translate(-50%, -50%); /* Ajuste para centralizar no meio */
  overflow: hidden; /* Remove a rolagem externa */
`;

export const TableWrapper = styled.div`
  max-height: calc(100% - 100px); /* Espaço ajustado para título e botão */
  overflow-y: auto; /* Rolagem apenas interna */
  margin-top: 20px; /* Espaçamento entre o cabeçalho e a tabela */
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  h2 {
    font-size: 2rem;
    font-weight: bold;
    color: #222;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  button {
    font-size: 28px;
    background: none;
    border: none;
    cursor: pointer;
    color: #cf0505;
    transition: color 0.2s;
    &:hover {
      color: #800000;
    }
  }
`;

export const StyledTable2 = styled.table`
  width: 100%;
  border-collapse: collapse;

  thead {
    background-color: #f9f9f9;
    border-bottom: 2px solid #ddd;

    th {
      padding: 10px;
      text-align: left;
      font-weight: bold;
      color: #555;
    }
  }

  tbody {
    tr {
      cursor: pointer;
      border-bottom: 1px solid #ddd;
      transition: background-color 0.3s;

      &:hover {
        background-color: #f1f1f1;
      }

      td {
        padding: 10px;
        color: #444;
      }
    }
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px; /* Alterado para alinhar no canto superior direito */
  background: none;
  border: none;
  color: #d9534f;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    color: #c9302c; /* Cor mais escura no hover */
  }
`;

export const EmptyMessage = styled.p`
  text-align: center;
  color: #999;
  font-size: 16px;
  margin-top: 20px;
`;

export const BackButton = styled.button`
    position: absolute;
    top: 100px;
    left: 20px;
    background-color: transparent;
    border: none;
    font-size: 16px;
    color: #cf0505;
    cursor: pointer;
    display: flex;
    align-items: center;

    &:hover {
        color: #800000;
    }
`;

export const TopActions = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  justify-content: center;
  flex-wrap: wrap;
`;

export const ActionInputWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

export const ScrollableTableArea = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 16px 0 16px;
  width: 100%;
  min-height: 400px;
  max-height: none;
`;

export const EditButton = styled.button`
  background: #1976d2;
  color: #fff;
  border: none;
  padding: 6px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
  &:hover {
    background: #125ea2;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
`;            